/* eslint-disable react/jsx-no-bind */
import React from 'react';
import get from 'lodash/get';
import flatten from 'lodash/flatten';
import map from 'lodash/map';
import {Field, FieldArray, FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../res/translations/messages';
import Error from '../Error';
import MinusButton from './editor/MinusButton';
import FilterButton from './editor/FilterButton';
import ExpressionType from './editor/ExpressionType';

const SurveyAlertsType = ({form, name, push, remove}) => {
    const values = get(form.values, name) || [];
    const pages = get(form.values, 'editor.pages') || [];
    const items = flatten(map(pages, 'items'));
    const extraFields = form.values.extraFields || [];
    const parameters = form.values.parameters || [];

    const addAlert = React.useCallback(() => {
        push({filter: [], subject: '', message: '', address: ''});
    }, [push]);

    return (
        <div>
            {values.map((alert, index) => (
                <div className="card mb-3" key={index}>
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                            <h5>
                                <FormattedMessage {...messages.surveys.form.label.alerts.rowTitle} values={{index: index + 1}} />
                            </h5>
                            <MinusButton remove={remove} index={index} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="col-form-label">
                                        <FormattedMessage {...messages.surveys.form.label.alerts.filter} />
                                    </label>
                                    <FieldArray name={`${name}.${index}.filter`}
                                        render={(arrayHelpers) => (
                                            <Field name={`${name}.${index}.filter`}
                                                previousPages={pages}
                                                items={items}
                                                extraFields={extraFields}
                                                parameters={parameters}
                                                component={ExpressionType}
                                                push={arrayHelpers.push}
                                                remove={arrayHelpers.remove}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="col-form-label" htmlFor={`${name}-${index}-address`}>
                                        <FormattedMessage {...messages.surveys.form.label.alerts.address} />
                                    </label>
                                    <FastField id={`${name}-${index}-address`} name={`${name}.${index}.address`} type="text"
                                        className={classNames('form-control',
                                            {error: get(form.errors, `${name}.${index}.address`) && get(form.touched, `${name}.${index}.address`)})} />
                                    <ErrorMessage name={`${name}.${index}.address`}>
                                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                    </ErrorMessage>
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label" htmlFor={`${name}-${index}-subject`}>
                                        <FormattedMessage {...messages.surveys.form.label.alerts.subject} />
                                    </label>
                                    <FastField id={`${name}-${index}-subject`} name={`${name}.${index}.subject`} type="text"
                                        className={classNames('form-control',
                                            {error: get(form.errors, `${name}.${index}.subject`) && get(form.touched, `${name}.${index}.subject`)})} />
                                    <ErrorMessage name={`${name}.${index}.subject`}>
                                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                    </ErrorMessage>
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label" htmlFor={`${name}-${index}-message`}>
                                        <FormattedMessage {...messages.surveys.form.label.alerts.message} />
                                    </label>
                                    <FastField id={`${name}-${index}-message`} name={`${name}.${index}.message`} component="textarea"
                                        className={classNames('form-control',
                                            {error: get(form.errors, `${name}.${index}.message`) && get(form.touched, `${name}.${index}.message`)})} />
                                    <ErrorMessage name={`${name}.${index}.message`}>
                                        {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                    </ErrorMessage>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <FilterButton onClick={addAlert}>
                <FormattedMessage {...messages.surveys.form.label.alerts.add} />
            </FilterButton>
        </div>
    );
};

export default SurveyAlertsType;
